// export const getOS = () => {
//   // 判断所处操作系统
//   const sUserAgent = navigator.userAgent.toLowerCase()
//   const isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Win64') || (navigator.platform === 'wow64')
//   const isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel')
//   if (isMac) return 'Mac'
//   const isUnix = (navigator.platform === 'X11') && !isWin && !isMac
//   if (isUnix) return 'Unix'
//   const isLinux = (String(navigator.platform).indexOf('Linux') > -1)
//   const bIsAndroid = sUserAgent.toLowerCase().match(/android/i) === 'android'
//   if (isLinux) {
//     if (bIsAndroid) return 'Android'
//     else return 'Linux'
//   }
//   if (isWin) {
//     const digits = getDigits()
//     const isWin2K = sUserAgent.indexOf('Windows nt 5.0') > -1 || sUserAgent.indexOf('Windows 2000') > -1
//     if (isWin2K) return 'Win2000 ' + digits
//     const isWinXP = sUserAgent.indexOf('Windows nt 5.1') > -1 || sUserAgent.indexOf('Windows XP') > -1
//     if (isWinXP) return 'WinXP ' + digits
//     const isWin2003 = sUserAgent.indexOf('Windows nt 5.2') > -1 || sUserAgent.indexOf('Windows 2003') > -1
//     if (isWin2003) return 'Win2003 ' + digits
//     const isWinVista = sUserAgent.indexOf('Windows nt 6.0') > -1 || sUserAgent.indexOf('Windows Vista') > -1
//     if (isWinVista) return 'WinVista ' + digits
//     const isWin7 = sUserAgent.indexOf('Windows nt 6.1') > -1 || sUserAgent.indexOf('Windows 7') > -1
//     if (isWin7) return 'Win7 ' + digits
//     const isWin8 = sUserAgent.indexOf('windows nt 6.2') > -1 || sUserAgent.indexOf('Windows 8') > -1
//     if (isWin8) return 'Win8 ' + digits
//     const isWin10 = sUserAgent.indexOf('windows nt 10.0') > -1 || sUserAgent.indexOf('Windows 10') > -1
//     if (isWin10) return 'Win10 ' + digits
//   }
//   return '其他'
// }

// export const getDigits = () => { // 判断当前操作系统的版本号
//   const sUserAgent = navigator.userAgent.toLowerCase()
//   const is64 = sUserAgent.indexOf('win64') > -1 || sUserAgent.indexOf('wow64') > -1
//   if (is64) {
//     return '64位'
//   } else {
//     return '32位'
//   }
// }

export const getBrowser = () => {
  const ua = navigator.userAgent.toLowerCase()

  const isBraveBrowser = () => {
    const isBrave = !!window.navigator.brave
    return isBrave
  }
  if (isBraveBrowser()) {
    const chromeMatch = ua.match(/(chrome)\/([\w.]+)/i)
    return {
      browser: 'Brave',
      version: 'Chrome/' + (chromeMatch && chromeMatch[2] ? chromeMatch[2] : '未知'),
      core: 'Blink'
    }
  }

  let matchBS

  // 1. 优先检测微信浏览器 [6](@ref)
  if (/micromessenger/i.test(ua)) {
    const match = ua.match(/micromessenger\/([\d.]+)/i)
    return {
      browser: '微信浏览器',
      version: 'X5/' + (match && match[1] ? match[1] : '未知'),
      core: 'X5 WebKit'
    }
  }

  // 2. 精确识别360浏览器 [4,5](@ref)
  const is360 = () => {
    if (/360se|360ee|qihu 360se|qihu 360ee/i.test(ua)) return true
    // 特征检测：360特有插件
    try {
      for (const plugin of (navigator.plugins || [])) {
        if (plugin.filename === 'np-mswmp.dll') return true
      }
    } catch (e) {}
    return false
  }
  if (is360()) {
    const chromeMatch = ua.match(/chrome\/([\d.]+)/i)
    return {
      browser: /mobile/i.test(ua) ? '360手机浏览器' : '360安全/极速浏览器',
      version: 'Chrome/' + (chromeMatch && chromeMatch[1] ? chromeMatch[1] : '未知'),
      core: 'Blink(极速) + Trident(兼容)'
    }
  }

  // 3. 新增夸克浏览器检测 [2](@ref)
  if (/quark|quarkbrowser/i.test(ua)) {
    const quarkMatch = /(quarkpc)\/([\w.]+)/

    const quarkBS = quarkMatch.exec(ua)
    if (quarkBS) {
      return {
        browser: '夸克浏览器',
        version: 'Quark/' + (quarkBS[2] || '未知'),
        core: 'Blink'
      }
    }

    const chromeMatch = ua.match(/chrome\/([\d.]+)/i)
    return {
      browser: '夸克浏览器',
      version: 'Chrome/' + (chromeMatch && chromeMatch[1] ? chromeMatch[1] : '未知'),
      core: 'Blink'
    }
  }

  // 4. 原有浏览器检测逻辑优化（重点修复搜狗/QQ等）
  const detectors = [
    // IE/Edge (保留原逻辑)
    { regex: /(msie\s|trident\/7)([\w.]+)/, name: 'Microsoft IE', core: 'Trident' },
    { regex: /(edge)\/([\w.]+)/, name: 'Microsoft Edge', core: 'EdgeHTML' },
    // 搜狗浏览器 [3](@ref)
    { regex: /(metasr|sogoumobilebrowser)[/\s]([\w.]+)/, name: '搜狗浏览器', core: 'Blink+Trident' },
    // QQ浏览器
    { regex: /(qqbrowser|mqqbrowser)\/([\w.]+)/, name: 'QQ浏览器', core: 'Blink' },
    // 其他浏览器...
    { regex: /(firefox)\/([\w.]+)/, name: '火狐浏览器', core: 'Gecko' },
    { regex: /(opera|opr).+version\/([\w.]+)/, name: 'Opera', core: 'Blink' },
    { regex: /(opera|opr)\/([\w.]+)/, name: 'Opera', core: 'Blink' },
    // brave浏览器
    { regex: /(brave)\/([\w.]+)/, name: 'Brave', core: 'Blink' },
    // vivaldi浏览器
    { regex: /(vivaldi)\/([\w.]+)/, name: 'Vivaldi', core: 'Blink' },
    // 新版edge
    { regex: /(edgios|edg|edge-chromium)\/([\w.]+)/, name: 'Microsoft Edge', core: 'EdgeHTML' },
    { regex: /(chrome)\/([\w.]+)/, name: 'Chrome', core: 'Chromium' },
    { regex: /version\/([\w.]+).*(safari)/, name: 'Safari', core: 'WebKit' }
  ]

  for (const { regex, name, core } of detectors) {
    if ((matchBS = regex.exec(ua))) {
      if (name === 'Safari') {
        const versionMatch = ua.match(/version\/([\w.]+)/)
        return {
          browser: name,
          version: versionMatch ? `${name.split(' ')[0]}/${versionMatch[1]}` : '未知',
          core
        }
      }

      return {
        browser: name,
        version: matchBS[2] ? `${name.split(' ')[0]}/${matchBS[2]}` : '未知',
        core
      }
    }
  }

  // 5. 兜底逻辑
  return {
    browser: '未知浏览器',
    version: '未知',
    core: '未知内核'
  }
}

// 无用
const os = require('os')
// cpu信息
export const getCpuInfo = () => {
  const objArray = os.cpus()
  if (objArray && objArray.length > 0) {
    return objArray[0].model ? objArray[0].model : '暂无获取权限'
  }
  return '暂无获取权限'
}
// 内存信息
export const getRam = () => {
  const mem = (os.totalmem() / (1024 * 1024 * 1024)).toFixed(2)
  return mem
}
// 获取cpu内核数量
export const getCpuNum = () => {
  // 若无cpu获取权限默认结果为0
  const hasCPUInfo = os.cpus() && os.cpus().length > 0
  return hasCPUInfo ? os.cpus().length : 0
}
// 获取显卡信息
export const getGpuInfo = () => {
  const canvas = document.createElement('canvas')
  const gl = canvas.getContext('experimental-webgl')
  let debugInfo
  if (gl) {
    debugInfo = gl.getExtension('WEBGL_debug_renderer_info')
    return debugInfo && gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL)
  }
  return false
}

// 获取系统和版本
const root = typeof self !== 'undefined' ? self : this
// 变量库
const VariableLibrary = {
  navigator: typeof root.navigator !== 'undefined' ? root.navigator : {},
  // 信息map
  infoMap: {
    engine: ['WebKit', 'Trident', 'Gecko', 'Presto'],
    browser: ['Chrome', 'Safari', 'Edge', 'IE', 'Firefox', 'Firefox Focus', 'Chromium', 'Opera', 'Vivaldi', 'Yandex', 'Arora', 'Lunascape', 'QupZilla', 'Coc Coc', 'Kindle', 'Iceweasel', 'Konqueror', 'Iceape', 'SeaMonkey', 'Epiphany', '360', '360SE', '360EE', 'UC', 'QQBrowser', 'QQ', 'Baidu', 'Maxthon', 'Sogou', 'LBBROWSER', '2345Explorer', 'TheWorld', 'XiaoMi', 'Quark', 'Qiyu', 'Wechat', 'Taobao', 'Alipay', 'Weibo', 'Douban', 'Suning', 'iQiYi'],
    os: ['Windows', 'Linux', 'Mac OS', 'Android', 'Ubuntu', 'FreeBSD', 'Debian', 'iOS', 'Windows Phone', 'BlackBerry', 'MeeGo', 'Symbian', 'Chrome OS', 'WebOS'],
    device: ['Mobile', 'Tablet', 'iPad']
  }
}
// 获取匹配库
const getMatchMap = function (u) {
  return {
    // 内核
    'Trident': u.indexOf('Trident') > -1 || u.indexOf('NET CLR') > -1,
    'Presto': u.indexOf('Presto') > -1,
    'WebKit': u.indexOf('AppleWebKit') > -1,
    'Gecko': u.indexOf('Gecko/') > -1,
    // 浏览器
    'Safari': u.indexOf('Safari') > -1,
    'Chrome': u.indexOf('Chrome') > -1 || u.indexOf('CriOS') > -1,
    'IE': u.indexOf('MSIE') > -1 || u.indexOf('Trident') > -1,
    'Edge': u.indexOf('Edge') > -1,
    'Firefox': u.indexOf('Firefox') > -1 || u.indexOf('FxiOS') > -1,
    'Firefox Focus': u.indexOf('Focus') > -1,
    'Chromium': u.indexOf('Chromium') > -1,
    'Opera': u.indexOf('Opera') > -1 || u.indexOf('OPR') > -1,
    'Vivaldi': u.indexOf('Vivaldi') > -1,
    'Yandex': u.indexOf('YaBrowser') > -1,
    'Arora': u.indexOf('Arora') > -1,
    'Lunascape': u.indexOf('Lunascape') > -1,
    'QupZilla': u.indexOf('QupZilla') > -1,
    'Coc Coc': u.indexOf('coc_coc_browser') > -1,
    'Kindle': u.indexOf('Kindle') > -1 || u.indexOf('Silk/') > -1,
    'Iceweasel': u.indexOf('Iceweasel') > -1,
    'Konqueror': u.indexOf('Konqueror') > -1,
    'Iceape': u.indexOf('Iceape') > -1,
    'SeaMonkey': u.indexOf('SeaMonkey') > -1,
    'Epiphany': u.indexOf('Epiphany') > -1,
    '360': u.indexOf('QihooBrowser') > -1 || u.indexOf('QHBrowser') > -1,
    '360EE': u.indexOf('360EE') > -1,
    '360SE': u.indexOf('360SE') > -1,
    'UC': u.indexOf('UC') > -1 || u.indexOf(' UBrowser') > -1,
    'QQBrowser': u.indexOf('QQBrowser') > -1,
    'QQ': u.indexOf('QQ/') > -1,
    'Baidu': u.indexOf('Baidu') > -1 || u.indexOf('BIDUBrowser') > -1,
    'Maxthon': u.indexOf('Maxthon') > -1,
    'Sogou': u.indexOf('MetaSr') > -1 || u.indexOf('Sogou') > -1,
    'LBBROWSER': u.indexOf('LBBROWSER') > -1,
    '2345Explorer': u.indexOf('2345Explorer') > -1,
    'TheWorld': u.indexOf('TheWorld') > -1,
    'XiaoMi': u.indexOf('MiuiBrowser') > -1,
    'Quark': u.indexOf('Quark') > -1,
    'Qiyu': u.indexOf('Qiyu') > -1,
    'Wechat': u.indexOf('MicroMessenger') > -1,
    'Taobao': u.indexOf('AliApp(TB') > -1,
    'Alipay': u.indexOf('AliApp(AP') > -1,
    'Weibo': u.indexOf('Weibo') > -1,
    'Douban': u.indexOf('com.douban.frodo') > -1,
    'Suning': u.indexOf('SNEBUY-APP') > -1,
    'iQiYi': u.indexOf('IqiyiApp') > -1,
    // 系统或平台
    'Windows': u.indexOf('Windows') > -1,
    'Linux': u.indexOf('Linux') > -1 || u.indexOf('X11') > -1,
    'Mac OS': u.indexOf('Macintosh') > -1,
    'Android': u.indexOf('Android') > -1 || u.indexOf('Adr') > -1,
    'Ubuntu': u.indexOf('Ubuntu') > -1,
    'FreeBSD': u.indexOf('FreeBSD') > -1,
    'Debian': u.indexOf('Debian') > -1,
    'Windows Phone': u.indexOf('IEMobile') > -1 || u.indexOf('Windows Phone') > -1,
    'BlackBerry': u.indexOf('BlackBerry') > -1 || u.indexOf('RIM') > -1,
    'MeeGo': u.indexOf('MeeGo') > -1,
    'Symbian': u.indexOf('Symbian') > -1,
    'iOS': u.indexOf('like Mac OS X') > -1,
    'Chrome OS': u.indexOf('CrOS') > -1,
    'WebOS': u.indexOf('hpwOS') > -1,
    // 设备
    'Mobile': u.indexOf('Mobi') > -1 || u.indexOf('iPh') > -1 || u.indexOf('480') > -1,
    'Tablet': u.indexOf('Tablet') > -1 || u.indexOf('Nexus 7') > -1,
    'iPad': u.indexOf('iPad') > -1
  }
}
// 在信息map和匹配库中进行匹配
const matchInfoMap = function (data) {
  const u = VariableLibrary.navigator.userAgent || {}
  const match = getMatchMap(u)
  for (let i = 0; i < data.length; i++) {
    const value = data[i]
    if (match[value]) {
      return value
    }
  }
}
// 获取当前操作系统
const getOS = function () {
  return matchInfoMap(VariableLibrary.infoMap.os)
}
// 获取操作系统和版本
const getOSInfo = function () {
  const u = VariableLibrary.navigator.userAgent || {}
  // 系统版本信息
  const osVersion = {
    'Windows': function () {
      const v = u.replace(/^.*Windows NT ([\d.]+);.*$/, '$1')
      const oldWindowsVersionMap = {
        '6.4': '10',
        '6.3': '8.1',
        '6.2': '8',
        '6.1': '7',
        '6.0': 'Vista',
        '5.2': 'XP',
        '5.1': 'XP',
        '5.0': '2000'
      }
      return oldWindowsVersionMap[v] || v
    },
    'Android': function () {
      return u.replace(/^.*Android ([\d.]+);.*$/, '$1')
    },
    'iOS': function () {
      return u.replace(/^.*OS ([\d_]+) like.*$/, '$1').replace(/_/g, '.')
    },
    'Debian': function () {
      return u.replace(/^.*Debian\/([\d.]+).*$/, '$1')
    },
    'Windows Phone': function () {
      return u.replace(/^.*Windows Phone( OS)? ([\d.]+);.*$/, '$2')
    },
    'Mac OS': function () {
      return u.replace(/^.*Mac OS X ([\d_]+).*$/, '$1').replace(/_/g, '.')
    },
    'WebOS': function () {
      return u.replace(/^.*hpwOS\/([\d.]+);.*$/, '$1')
    }
  }
  const os = getOS()
  let version = ''
  if (osVersion[os]) {
    version = osVersion[os]()
    if (version === u) {
      version = ''
    }
  }
  return { os: os, osVersion: version }
}
// 获取设备类型
export const getDeviceType = function () {
  return matchInfoMap(VariableLibrary.infoMap.device) || 'PC'
}

// 汇总
export const getDetectInfo = () => {
  const {
    browser,
    version: browserVersion,
    core
  } = getBrowser()
  // 系统版本和版本号
  const { os, osVersion } = getOSInfo()
  return {
    browser: browser || '未知浏览器',
    browserVersion: browserVersion || '未知浏览器版本',
    OS: os || '未知操作系统',
    osVersion: osVersion || '未知操作系统版本',
    core: core || '未知内核'
  }
}
